<app-loader></app-loader>

<div [ngClass]="{'forgot-page': true, 'popup-mode': isPopup}">
  <div class="forgot-page__overlay"></div>

  <div class="forgot-card">
    <div class="forgot-card__top">
      <button type="button" class="icon-button" (click)="goBack()" aria-label="Go back">
        <i class="fas fa-arrow-left"></i>
      </button>
      <button type="button" class="icon-button" (click)="goBack()" aria-label="Close">
        ×
      </button>
    </div>

    <div class="forgot-card__icon">
      <i class="fas fa-key"></i>
    </div>

    <div class="forgot-card__title">
      <h1>FORGOT PASSWORD</h1>
      <p>Enter your email and we'll send a reset code.</p>
    </div>

    <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()" autocomplete="off" class="forgot-form">
      <div class="form-group input-with-icon">
        <i class="fas fa-envelope"></i>
        <input
          id="email"
          type="email"
          formControlName="email"
          placeholder="your@email.com"
          class="input-field"
        />
      </div>
      <div *ngIf="forgotPasswordForm.get('email')?.invalid && forgotPasswordForm.get('email')?.touched" class="error-text">
        Email is required and must be valid.
      </div>

      <button type="submit" [disabled]="forgotPasswordForm.invalid" class="primary-button">
        SEND RESET CODE
      </button>
    </form>
  </div>
</div>
